export default __webpack_public_path__ + "static/media/poop.c5cd462e.svg";